import { MessageType } from 'kb-shared';
import { gql } from 'apollo-boost';

export interface ConversationResponse {
  conversation: {
    id: string;
    patientId: number;
    category: string;
    subject: string;
    status: string;
    assignedToUserName: string;
    assignedToUserRole: string;
    assignedToUserPhotoUrl: string;
    preview: string;
    unreadCount: number;
    lastMessageTimestamp: Date;
    messages: Array<MessageType>;
  };
}

export const CONVERSATION_QUERY = gql`
  query conversation($id: Int!) {
    conversation(id: $id) {
      id
      patientId
      category
      subject
      status
      assignedToUserName
      assignedToUserRole
      assignedToUserPhotoUrl
      preview
      unreadCount
      lastMessageTimestamp

      messages {
        id
        read
        body
        fromPatient
        createdAt
        senderPhotoUrl
        senderName
        senderRole
        attachments {
          fileName
          file
          id
          uuid
        }
      }
    }
  }
`;
